import { Input, OnInit, Component, ElementRef, HostListener, HostBinding, ViewChildren, ViewEncapsulation } from '@angular/core';

import { AppState } from '../app.service';
import { Title } from './title';
import { CustomFormComponent } from '../stripe/CustomFormComponent';

import { FeedService } from './feed.service';
import { FeedEntry } from './model/feed-entry';

import { Http, Headers } from '@angular/http';

// Add the RxJS Observable operators we need in this app.
import './rxjs-operators';

@Component({
  // The selector is what angular internally uses
  // for `document.querySelectorAll(selector)` in our index.html
  // where, in this case, selector is the string 'home'
  selector: 'home',  // <home></home>
  // We need to tell Angular's Dependency Injection which providers are in our app.
  providers: [
    Title
  ],
  // Our list of styles in our component. We may add more to compose many styles together
  // styles: [ require('./home.component.css') ],
  // Every Angular template is first compiled by the browser before Angular runs it's compiler
  template: require('./home.component.html'),
  encapsulation: ViewEncapsulation.None

})
export class HomeComponent {

  public code1: number = Math.floor((Math.random() * 20) + 1);
  public code2: number = Math.floor((Math.random() * 20) + 1);
  public error: string;
  public answer: number;

  // title: string = 'My first angular2-google-maps project';
  lat: number = 28.6299;
  lng: number = 77.0908;

 

  open_resume() {
    document.getElementById('resume_chk').click();
  }
  open_portfolio() {
    document.getElementById('portfolio_chk').click();
  }
  open_contact() {
    document.getElementById('contact_chk').click();
  }
  open_smashingmag() {
    document.getElementById('smashingmag_chk').click();
  }
  open_services() {
    document.getElementById('services_chk').click();
  }
  open_logo(){
    document.getElementById('logo_chk').click();
  }
  open_template(){
    document.getElementById('template_chk').click();
  }
  open_shutter(){
    document.getElementById('shutter_chk').click();
    document.getElementById('close_shutter').click();
  }
  open_icons(){
    document.getElementById('icons_chk').click();
  }
  open_pdf(){
    document.getElementById('pdf_chk').click();
  }

  // private feedUrl: string = 'https%3A%2F%2Fwww.becompany.ch%2Fen%2Fblog%2Ffeed.xml';
  private feedUrl: string = 'https%3A%2F%2Fwww.amazon.in%2Frss%2Fbestsellers%2Fbooks%3Ftag%3Dsuccess04-21';
  // private feedUrl: string = 'https%3A%2F%2Fwww.amazon.in%2Frss%2Fbestsellers%2Fbooks';
  feeds: Array<FeedEntry> = [];

  // http://www.sgi-usa.org/rss/podcasts/hopefilled_podcast.rss

  constructor(
    private feedService: FeedService, private http: Http,

  ) { }

  @Input() feed: any;

  ngOnInit() {
    this.refreshFeed();
  }

  refreshFeed() {
    this.feeds.length = 0;
    // Adds 1s of delay to provide user's feedback.
    this.feedService.getFeedContent(this.feedUrl).delay(1000)
      .subscribe(
      feed => this.feeds = feed.items,
      error => console.log(error));
  }

  openLinkInBrowser() {
    window.open(this.feed.link);
  }

  onSubmit() {

    this.error = null;
    if ((this.code1 + this.code2) == this.answer) {
      this.answer = null;
      document.getElementById('sender').click();
    } else {
      this.error = "Argh! The math is not right!";
    }

  }


  mini_click(id) {
    document.getElementById(id).click();
  }


}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/home/home.component.ts